module.exports = __webpack_public_path__ + "img/icon_win.c587c3da.png";